import React from 'react';
import PropTypes from 'prop-types';
import { ListGroup } from 'reactstrap';

import ListGroupItem from './ListGroupItem';

const ListGroupNotes = ({
  notes,
  options,
}) => {
  return notes.length ? (
    <ListGroup>
      {notes.map(d => (
        <ListGroupItem
          key={d.id}
          data={{ ...d, ...d.attributes }}
          options={options}
        />
      ))}
    </ListGroup>
  ) : <p>No notes found!</p>;
};

ListGroupNotes.propTypes = {
  notes: PropTypes.arrayOf(PropTypes.shape()),
  options: PropTypes.shape({}),
};

ListGroupNotes.defaultProps = {
  notes: [],
  options: undefined,
};

export default ListGroupNotes;
